import { Controller } from '@hotwired/stimulus'

// Off-canvas admin sidebar on narrow screens. A Turbo visit renders a fresh
// body, so following a menu link closes it without extra code.
export default class extends Controller {
  static targets = ['sidebar', 'overlay']

  open() {
    this.sidebarTarget.classList.remove('-translate-x-full')
    this.overlayTarget.classList.remove('hidden')
  }

  close() {
    this.sidebarTarget.classList.add('-translate-x-full')
    this.overlayTarget.classList.add('hidden')
  }
}
